import { SourceComponents } from '@updater/informant-core';
import { DropDownSelect } from '@updater/ui-uds';

export const SelectField: SourceComponents['SelectField'] = (props) => {
  return <DropDownSelect {...props} />;
};
